import { render, staticRenderFns } from "./template.vue?vue&type=template&id=ac98fb50&scoped=true&"
import script from "./template.vue?vue&type=script&lang=js&"
export * from "./template.vue?vue&type=script&lang=js&"
import style0 from "./template.vue?vue&type=style&index=0&id=ac98fb50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac98fb50",
  null
  
)

export default component.exports